module.exports = __webpack_public_path__ + "img/main_image1.11fbd3ff.png";